import { Component, OnInit } from '@angular/core';
import * as xml2js from 'xml2js';
import { ItemService } from './video-tutorial.service';
import * as _ from 'lodash';

@Component({
	selector: 'app-video-tutorial',
	templateUrl: './video-tutorial.component.html',
	styleUrls: ['./video-tutorial.component.styl']
})
export class VideoTutorialComponent implements OnInit {
	isDiscount: number;
	isMultiTax: number;
	messege: string;

	constructor(
		private service: ItemService,
	) { }

	ngOnInit() {

	}
	
	mapArray(invoice: any) {
		return _.forOwn(invoice, function (value, key) {
			if (value[0] && !value[1]) {
				invoice[key] = value[0];
			}
		});
	}

	verify() {
	}

	private onSaveSuccess(result: any) {
	}

	private onSaveError(error) {
	}

}

